export const ShopifyChannelDesciption = [
  {
    id: 1,
    title: 'Name of the Store',
    key: 'CloudStore.name',
  },
  {
    id: 2,
    title: 'Address of the Store',
    key: 'CloudStore.address1',
  },
  {
    id: 3,
    title: 'Country of the Store',
    key: 'CloudStore.country',
  },
  {
    id: 4,
    title: 'Created at',
    key: 'CloudStore.created_at',
  },
  {
    id: 5,
    title: 'Email of the Store',
    key: 'CloudStore.email',
  },
  {
    id: 6,
    title: 'Domain of the Store',
    key: 'CloudStore.domain',
  },
];

export const a = 1;
